import { render, staticRenderFns } from "./mIndex.vue?vue&type=template&id=2085ad6a"
import script from "./mIndex.vue?vue&type=script&lang=js"
export * from "./mIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports